import React, { Fragment } from "react";
import { SovosGrid, SovosBox, SovosTypography, SovosPaper, SovosDivider } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const buildAuditSchemaLabels = (obj, i18n) => {
    return (Object.keys(obj) || []).map((key, index) => {
        return (
            <Fragment key={index}>
                <SovosGrid item xs={6}>
                    <SovosTypography variant="body2">
                        <strong>{i18n`${key}` + ":"}</strong>
                    </SovosTypography>
                </SovosGrid>
                <SovosGrid item xs={6} textAlign="right">
                    <SovosTypography variant="body2" textAlign="right">
                        {obj[key]}
                    </SovosTypography>
                </SovosGrid>
            </Fragment>
        );
    });
};

export default function AuditSchemaDetails(props) {
    const { i18n } = useGlobalValue();
    const { detailPanel } = props || {};
    const { data } = detailPanel || {};
    const errorData = {
        message: data?.F3 || "N/A",
        type: data?.F4 || "N/A",
        lineNumber: data?.F1 || "N/A",
        columnNumber: data?.F2 || "N/A",
        xmlBlock: data?.F6 || "N/A",
    };
    const { message, ...restErrorData } = errorData;
    const auditSchemaLabels = { ...restErrorData };

    return (
        <SovosPaper elevation={3} sx={{ padding: 2, margin: 2 }}>
            <SovosTypography variant="h6" gutterBottom>
                {i18n`Message`}
            </SovosTypography>
            <SovosTypography variant="body1" gutterBottom>
                {errorData.message}
            </SovosTypography>
            <SovosDivider />
            <SovosBox sx={{ marginTop: 2 }}>
                <SovosGrid container spacing={2}>
                    {buildAuditSchemaLabels(auditSchemaLabels, i18n)}
                </SovosGrid>
            </SovosBox>
        </SovosPaper>
    );
}
